import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { userSlice, userActions } from './Stores/UserStore';
import { drawTicketActions, drawTicketSlice } from './Stores/DrawTicketStore';
import { entrySlice, entryActions } from './Stores/EntryStore';
import { promotionSlice, promotionsActions } from './Stores/PromotionStore';
import { loadingSlice, loadingActions } from './Stores/LoadingStore';
import { drawingSlice, drawingActions } from './Stores/DrawingStore';
import { feedbackSlice, feedbackActions } from './Stores/FeedbackStore';
import { gameSlice, gameActions } from './Stores/GameStore';
import { animationSlice, animationActions } from './Stores/AnimationStore';
import { notificationSlice, notificationActions } from './Stores/NotificationStore';
import { configSlice, configActions } from './Stores/ConfigStore';
import { bannersSlice, bannersActions } from './Stores/BannerStore';

import { cmsSourceFirebaseActions, cmsSourceFirebaseSlice } from 'sg-ui-components';

export const createStore = () => {
    return configureStore({
        reducer: combineReducers({
            config: configSlice.reducer,
            user: userSlice.reducer,
            drawTicket: drawTicketSlice.reducer,
            entry: entrySlice.reducer,
            promotions: promotionSlice.reducer,
            banners: bannersSlice.reducer,
            drawings: drawingSlice.reducer,
            loading: loadingSlice.reducer,
            feedback: feedbackSlice.reducer,
            game: gameSlice.reducer,
            animation: animationSlice.reducer,
            notification: notificationSlice.reducer,
            cmsSourceFirebase: cmsSourceFirebaseSlice.reducer,
        }),
    });
};

export const actionsStore = (dispatch) => {
    return {
        configActions: configActions(dispatch),
        userActions: userActions(dispatch),
        drawTicketActions: drawTicketActions(dispatch),
        entryActions: entryActions(dispatch),
        promotionsActions: promotionsActions(dispatch),
        bannersActions: bannersActions(dispatch),
        loadingActions: loadingActions(dispatch),
        drawingActions: drawingActions(dispatch),
        feedbackActions: feedbackActions(dispatch),
        gameActions: gameActions(dispatch),
        animationActions: animationActions(dispatch),
        notificationActions: notificationActions(dispatch),
        cmsSourceFirebaseActions: cmsSourceFirebaseActions(dispatch),
    };
};

export const mapStateToProps = ({
    config,
    user,
    drawTicket,
    entry,
    promotions,
    loading,
    drawings,
    feedback,
    game,
    banners,
    animation,
    notification,
    cmsSourceFirebase,
}) => ({
    config,
    user,
    drawTicket,
    entry,
    promotions,
    banners,
    loading,
    drawings,
    feedback,
    game,
    animation,
    notification,
    cmsSourceFirebase,
});

export const mapDispatchToProps = (dispatch) => {
    return {
        actions: actionsStore(dispatch),
    };
};
